export default function getCoverageLabel(daysValue, monthlyDuration) {
  let title = ''
  if (monthlyDuration === 0) {
    title = `${daysValue} Days`
  } else {
    title = `${monthlyDuration} Months`
  }
  return title
}
